import { render } from "./tender_description.vue?vue&type=template&id=7918c04c"
import script from "./tender_description.vue?vue&type=script&lang=js"
export * from "./tender_description.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_description.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7918c04c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7918c04c', __exports__)) {
    console.log('reload')
    api.reload('7918c04c', __exports__)
  }
  
  module.hot.accept("./tender_description.vue?vue&type=template&id=7918c04c", () => {
    console.log('re-render')
    api.rerender('7918c04c', render)
  })

}


export default __exports__